import {get_token,get_user_details} from "@/router";
import Swal from 'sweetalert2';

import { client_domain } from "@/main.js";
import { handle_event_list_realtime } from "@/services/eventRealtimeHandlers";

export default {
  computed: {
    filteredEvents() {
      return this.showAll ? this.upcoming_events : this.upcoming_events.slice(0, this.visibleCount);
    }
  }
,  
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    const selectedEvent = JSON.parse(sessionStorage.getItem('selectedEvent'));
    const selectedExtras = JSON.parse(sessionStorage.getItem('selectedExtras')) || [];
    const selectedExtraItems = JSON.parse(sessionStorage.getItem('selectedExtraItems')) || [];
    const selectedItemId = JSON.parse(sessionStorage.getItem('selectedItemId')) || [];
    const businessName = JSON.parse(sessionStorage.getItem('businessName')) || '';
    const isFirstTime = JSON.parse(sessionStorage.getItem('isFirstTime')) || false;
    const chapter = JSON.parse(sessionStorage.getItem('chapter')) || '';



    const nextUrl = sessionStorage.getItem('next');

    if (nextUrl && this.token_exists) {

        this.selectedEvent = selectedEvent;
        this.selectedExtraId = selectedExtras;
        this.selectedExtraItemId = selectedExtraItems;
        this.selectedItemId = selectedItemId
        this.businessName = businessName;
        this.isFirstTime = isFirstTime;
        this.chapter = chapter;
        if (typeof this.addRsvp === 'function') {
          this.addRsvp()
          sessionStorage.removeItem('next');
          sessionStorage.removeItem('selectedEvent');
          sessionStorage.removeItem('selectedExtras');
          sessionStorage.removeItem('selectedExtraItems');
          sessionStorage.removeItem('selectedItemId')
          sessionStorage.removeItem('businessName');
          sessionStorage.removeItem('isFirstTime');
          sessionStorage.removeItem('chapter');
      }
    }
    this.fetch_user_events();
    if(client_domain.includes('soulcity') || client_domain.includes('nsp')) {
      this.soulcity_domain = true;
    }
    if(client_domain.includes('workbook')) {
      this.workbook_domain = true;
    }
    if(client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);

  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
  },

  data() {
    return ({
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
        'user_id': '',
      },
    user_events :[],
    upcoming_events :[],
    showAll: false, 
    visibleCount: 3,
    token_exists: false,
    selectedEvent: {},
    eventExtras: [],
    extraItems: [],
    selectedExtraId: [],
    selectedExtraItemId: [],
    selectedItemId: [],
    businessName: '',
    isFirstTime: false,
    chapter: '',
    loading: true,
    soulcity_domain: false,
    workbook_domain: false,
    cbo_domain:false,
    event_tickets: [],
    });
  },

  methods: {
    handle_realtime_event(event) {
      // This component uses `upcoming_events` and `user_events` (not `my_events`).
      handle_event_list_realtime(this, event, { list_names: ["upcoming_events", "user_events"] });
    },
    goToViewEvents() {
      this.$router.push('/view_events');
    },

    countLimitedChapterRSVPs(event) {
    const eventName = event.event_name?.toLowerCase() || "";
    const isLimitedEvent = eventName.includes("bedfordview") || eventName.includes("edenvale");
    const rsvpCount = event.rsvp_list?.length || 0;
    return isLimitedEvent && rsvpCount >= 35;
  },
    is_event_owner(event) {
      return String(event?.user?.id) === String(this.user_details?.user_id);
    },

    getToken() {
        return get_token();
      },
    toggleShowMore() {
      this.showAll = !this.showAll; // Toggle between showing all and limiting to visibleCount
    },
    formatMonth(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('default', { month: 'short' }).toUpperCase(); // e.g., "FEB"
    },
    formatDay(dateStr) {
      const date = new Date(dateStr);
      return date.getDate(); // e.g., 2
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      return `${weekday} ${day}${suffix}`;
    },
     form_time(timeString) {
      if (!timeString) return "";
      const [hour, minute] = timeString.split(":");
      const date = new Date();
      date.setHours(hour, minute);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    clearForm() {
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
      this.extraItems = [];
      this.event_name = '';
      this.start_date = '';
      this.end_date = '';
      this.event_description = '';
      this.selectedPortalId = '';
      this.organizer = '';
      this.location = '';
      this.rsvp_start_date = '';
      this.rsvp_end_date = '';
      this.upload_media = null;
      this.selectedExtraText = '';
      this.event_type = '';
      if (this.$refs.quillEventEditorRef) {
        this.$refs.quillEventEditorRef.setHTML('');

      };
      this.extraForms = [];
      this.show_add_extras=true


    },
    fetchExtras() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_extra/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.extras = data.extras;
          setTimeout(() => {
            this.loading = false;
        }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    selectEvent(event) {
      this.selectedEvent = event;
      if(event.is_free){
        $('#event_modal').modal('show')
      }
      else{
        $('#user_ticket_modal').modal('show');
      }
    },
    toggleItem(item_id) {
          const index = this.selectedItemId.indexOf(item_id);

          if (index > -1) {
              this.selectedItemId = [];
          } else {
              this.selectedItemId = [item_id];
          }
      },
    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.clearForm()
      this.selectedItemId=[]

      // Close the event modal before making the request
      $('#event_modal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addRsvp() {

          if(!this.token_exists){
            const nextUrl = this.$router.currentRoute.value.fullPath;
              if (nextUrl) {
                sessionStorage.setItem('next', nextUrl);
                sessionStorage.setItem('selectedEvent', JSON.stringify(this.selectedEvent));
                sessionStorage.setItem('selectedExtras', JSON.stringify(this.selectedExtraId));
                sessionStorage.setItem('selectedItemId',JSON.stringify(this.selectedItemId))
                sessionStorage.setItem('businessName', JSON.stringify(this.businessName));
                sessionStorage.setItem('isFirstTime', JSON.stringify(this.isFirstTime));
                sessionStorage.setItem('chapter', JSON.stringify(this.chapter));
              }
              window.location = '/sign_in_Finale';
              return;
          }
          this.isSubmitting = true;
          const formData = new FormData();
          formData.append('event_id', this.selectedEvent.id);
          if (Array.isArray(this.selectedItemId)) {
            this.selectedItemId.forEach(itemId => {
                formData.append('item_id', itemId);
            });
        } else {
            formData.append('item_id', this.selectedItemId);
        }
        formData.append('business_name', this.businessName || '');
        formData.append('is_first_time', this.isFirstTime ? 'True' : 'False');
        formData.append('chapter', this.chapter || '');
          $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_rsvp/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.selectedEvent.is_rsvped = true;
                Swal.fire({
                  icon: 'success',
                  title: 'RSVP Successful',
                  showConfirmButton: false,
                  timer: 2000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {

                  Swal.close();
                  sessionStorage.removeItem('selectedEvent');
                  sessionStorage.removeItem('selectedExtras');
                  sessionStorage.removeItem('selectedItemId');
                  sessionStorage.removeItem('businessName');
                  sessionStorage.removeItem('isFirstTime');
                  sessionStorage.removeItem('chapter');

                  this.selectedEvent = {};
                  this.selectedExtraId = [];
                  this.businessName = '';
                  $('#rsvp_modal').modal('hide');
                });
              }
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON;
              if (response_data.status === "error") {
                Swal.fire({
                  icon: 'info',
                  text: response_data.message,
                  showConfirmButton: false,
                  timer: 2000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  Swal.close();
                  sessionStorage.removeItem('selectedEvent');
                  sessionStorage.removeItem('selectedExtras');
                  sessionStorage.removeItem('selectedItemId');
                  sessionStorage.removeItem('businessName');
                  sessionStorage.removeItem('isFirstTime');
                  sessionStorage.removeItem('chapter');


                  this.selectedEvent = {};
                  this.selectedExtraId = [];
                  this.selectedItemId=[];
                  this.businessName = '';

                  $('#rsvp_modal').modal('hide');
                });
              }
            }

          })
        },
    fetch_user_events(){
      this.loading = true;
        var value = JSON.stringify({
          user_id:this.user_details.user_id,
          is_published: true
         })
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/filter_events_api/`,
            method: 'POST',
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            data:value,
            success: (response) => {
              if (response.status === 'success') {
                this.user_events = response.data.results;

                const today = new Date().toISOString().slice(0, 10);

          this.upcoming_events = this.user_events.filter(event => event.end_date >= today);

          this.loading = false;
          }
            },

            error: (xhr, status, error) => {
              console.error("Error fetching user events:", error);
              this.loading = false;
            }
          }); 
    },
    isWithinRSVPPeriod(event) {
      const now = new Date();
      const start = new Date(`${event?.rsvp_start_date}T${event?.rsvp_start_time}`);
      const end = new Date(`${event?.rsvp_end_date}T${event?.rsvp_end_time}`);
      if (now < start) {
        return ({ isValid: false, message: "RSVP has not started yet." });
      }
      if (now > end) {
        return ({ isValid: false, message: "RSVP period has ended." });
      }
      return ({ isValid: true, message: "" });
    },
    isEventStarted(event) {
      const now = new Date();
      // Combine date and time for start and end time
      const start = new Date(`${event.start_date}T${event.start_time}`);
      const end = new Date(`${event.end_date}T${event.end_time}`);

      var object={ canJoin: true, message: "" }
      // If the current time is before the event starts (checking both date and time)
      if (now < start) {
          object={ canJoin: false, message: "The event hasn't started yet." }
        return object;
      }
      // If the current time is after the event ends (checking both date and time)
      if (now > end) {
          object={ canJoin: false, message: "The event has ended." }
        return object;

      }
      return object;
    },
cancelRSVP(event_id) {
    const token = this.getToken();

    if (!Number.isInteger(event_id)) {
    Swal.fire({
      title: 'Invalid ID',
      text: 'The event ID is not valid.',
      icon: 'error',
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
      toast: true
    });
    return;
  }

  $.ajax({
    type: 'POST',
    url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/cancel_rsvp/`,
    contentType: 'application/json',
    data: JSON.stringify({ event_id: event_id }),
    headers: {
      'Authorization': `Token ${token}`
    },
    success: (data) => {
      if (data.status === 'success') {
          for (const event of this.user_events) {
          if (event.id === event_id) {
            event.is_rsvped = false;
            break;
          }
        }

        Swal.fire({
          icon: 'success',
          title: 'RSVP Cancelled',
          showConfirmButton: false,
          timer: 2000,
          position: 'bottom-end',
          toast: true
        }).then(() => {
          $('#event_modal').modal('hide');
        })
      } else {
        Swal.fire({
          title: 'Error',
          text: data.message || 'Cancel failed',
          icon: 'error',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
      }
    },
    error: (xhr) => {
      const response = xhr.responseJSON || {};
      Swal.fire({
        title: 'Error',
        text: response.message || 'Something went wrong',
        icon: 'error',
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
    }
  });
},
 openModal(event) {
    const eventWithTickets = {
    ...event, 
    event_tickets: (event.event_tickets || []).map(ticket => ({
      ...ticket,
      quantitySelected: 0
    }))
    };
    this.event_tickets = eventWithTickets.event_tickets
    this.selectEvent(eventWithTickets);
  },
  process_to_checkout() {
    const selectedTickets = this.event_tickets
      .filter(t => t.quantitySelected > 0)
      .map(t => ({
        ticket_id: t.id,
        quantity: t.quantitySelected,
      }));
    if (selectedTickets.length === 0) {
      Swal.fire({
        title: "No tickets selected",
        text: "Please choose at least one ticket.",
        icon: "warning",
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000,
        toast: true
      });
      return;
    }

    const request_data = {
      event_id: this.selectedEvent.id,
      user_id: this.user_details.user_id,
      tickets: selectedTickets
    };

    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/ticket_purchase_api/`,
      method: "POST",
      headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(request_data),
      success: (response) => {
        if (response.status === "success") {
          const orderData = response.data;
          $('#user_ticket_modal').modal('hide'); $('.modal-backdrop').remove();
          this.$router.push({ name: 'checkout', params: { order_id: orderData.id } });
        }
      },
      error: (xhr) => {
        Swal.fire({
          title: "Error",
          text: "Failed to create order.",
          icon: "error",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        console.error("AJAX error:", xhr.responseText);
      }
    });
  
    },
    checkAvailableTickets(user_event){
      return (user_event.event_tickets || []).some((item) => 
        item.available_instances > 0
      )
    },
  },
};

